// props that connect a MUI TextField to a formik form, including its validation message
const formikTextFieldProps = (formik, name) => ({
  ...formik.getFieldProps(name),
  error: formik.touched[name] && Boolean(formik.errors[name]),
  helperText: formik.touched[name] && formik.errors[name],
});

export default formikTextFieldProps;
